import Loader from "@/atoms-react/loader/Loader.react";
import { Base } from "@/atoms-react/text/Text.react";
import { EmptyPageCactusAnimation } from "@/components/animations/empty-cactus/index.react";
import { companyAdminNewListType } from "@/features/company/types";
import { useTranslation } from "react-i18next";
import { AdminNewCompaniesTableHeader } from "./admin-new-companies-table-header";
import { AdminNewCompaniesTableItem } from "./admin-new-companies-table-item";
import { Pagination } from "@/views/dashboard/components/transactions/pagination";

type listAdminProps = {
  listcompaniesResponse?: {
    companyList: companyAdminNewListType[];
    hasMore: boolean;
    count: number;
  };

  isLoading: boolean;
  page: number;
  limit: number;
  handleEdit: (company: companyAdminNewListType) => void;
  handlePage: (page: number) => void;
  handleLimit: (limit: number) => void;
  isPlaceholderData: boolean;
};
const ListCompanies = ({
  listcompaniesResponse,
  isLoading = false,
  handlePage,
  page = 1,
  handleEdit,
  handleLimit,
  limit
}: listAdminProps) => {
  const { t } = useTranslation(["pass"]);
  return (
    <div className="overflow-x-auto overflow-y-hidden rounded-sm border-0 border-slate-50 lg:overflow-x-hidden lg:p-0">
      <div className="flex flex-col">
        <AdminNewCompaniesTableHeader />

        <ul className="mt-2 min-w-sm rounded-sm rounded-sm border-slate-50 lg:min-w-0 lg:border-2 dark:border-slate-700">
          {isLoading ? (
            <div className="flex h-[400px] justify-center">
              <div className="flex h-[400px] flex-col items-center justify-center">
                <Loader />
              </div>
            </div>
          ) : !listcompaniesResponse?.companyList ||
            listcompaniesResponse?.companyList.length === 0 ? (
            <div className="flex h-[400px] justify-center">
              <div className="flex h-[400px] flex-col items-center justify-center">
                <EmptyPageCactusAnimation />
                <Base className="mt-4 mb-2"> {t("business.label.empty")}</Base>
              </div>
            </div>
          ) : (
            listcompaniesResponse?.companyList?.length > 0 &&
            listcompaniesResponse?.companyList?.map((company, index) => (
              <AdminNewCompaniesTableItem index={index} company={company} handleEdit={handleEdit} />
            ))
          )}
        </ul>

        {!isLoading &&
          listcompaniesResponse?.companyList &&
          listcompaniesResponse.companyList?.length > 0 && (
            <Pagination
              currentPage={page}
              handlePrev={() => handlePage(Math.max(page - 1, 0))}
              setLimit={(value: number) => handleLimit(value)}
              limit={limit}
              count={listcompaniesResponse.count ?? 0}
              totalPages={
                listcompaniesResponse?.count ? Math.ceil(listcompaniesResponse?.count / limit) : 1
              }
              onClick={(page: number) => {
                handlePage(page);
              }}
              handleNext={() => {
                const maxPage = listcompaniesResponse?.count
                  ? Math.ceil(listcompaniesResponse?.count / limit)
                  : 1;
                if (page < maxPage) {
                  handlePage(page + 1);
                }
              }}
            />
          )}
      </div>
    </div>
  );
};
export default ListCompanies;
